import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ListFunderComponent } from './list-funder/list-funder.component';
import { AddFunderModalComponent } from './modal/add-funder-modal/add-funder-modal.component';
import { EditFunderModalComponent } from './modal/edit-funder-modal/edit-funder-modal.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { GestionDonneesModule } from '../gestion-donnees/gestion-donnees.module';

@NgModule({
	declarations: [
		ListFunderComponent,
		AddFunderModalComponent,
		EditFunderModalComponent
	],
	imports: [SharedModule, GestionDonneesModule],
	providers: []
})
export class FundersModule {}
